/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1902772238 — localStorage стратегія */

import {
    SESSION_STORAGE_KEYS,
    SESSION_STORAGE_DEFAULTS,
    SessionStorageKeyName,
    SessionStorageValueMap,
} from './session-storage.data';

class SessionStorageService {
    private getStorageKey(name: SessionStorageKeyName): string {
        return SESSION_STORAGE_KEYS[name];
    }

    setItem<K extends SessionStorageKeyName>(key: K, value: SessionStorageValueMap[K]): void {
        try {
            sessionStorage.setItem(this.getStorageKey(key), value);
        } catch (error) {
            console.error({ module: 'shared', action: 'sessionStorage.setItem', key }, error);
        }
    }

    getItem<K extends SessionStorageKeyName>(key: K): SessionStorageValueMap[K] {
        try {
            const item = sessionStorage.getItem(this.getStorageKey(key));
            if (item === null) {
                return SESSION_STORAGE_DEFAULTS[key];
            }
            return item as SessionStorageValueMap[K];
        } catch (error) {
            console.error({ module: 'shared', action: 'sessionStorage.getItem', key }, error);
            return SESSION_STORAGE_DEFAULTS[key];
        }
    }

    removeItem(key: SessionStorageKeyName): void {
        sessionStorage.removeItem(this.getStorageKey(key));
    }

    clear(): void {
        sessionStorage.clear();
    }
}

export const sessionStorageService = new SessionStorageService();
